// src/Components/Forms/Financement/Penalite/Tab1.tsx
import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { Form, Spin } from 'antd';
import InputForm from '../../../../InputT';

interface Tab1Props {
  form: any;
  detail: any;
  loading: boolean;
}

function Tab1({ form, detail, loading }: Tab1Props) {
  return (
    <div className="tabItem">
      <Form form={form} layout="horizontal" style={{ width: '100%' }}>
        <Box width={'100%'} padding={2}>
          <Typography variant="subtitle1" color="primary" sx={{ mb: 2 }}>
            Informations détaillées
          </Typography>
          <Spin spinning={loading}>
            <Grid container spacing={2}>
              {/* 1ère colonne */}
              <Grid item xs={12} md={6}>
                <InputForm disabled label="ID Pénalité" name="PenaliteID" type="text" width={8} />
                <InputForm disabled label="Type Financement" name="CodeFinancement" type="text" width={8} />
                <InputForm disabled label="Numéro Financement" name="NumeroFinancement" type="text" width={8} />
                <InputForm disabled label="Client" name="Nomcli" type="text" width={8} />
                <InputForm disabled label="N° Échéance" name="NumeroEcheance" type="number" width={8} />
                <InputForm disabled label="Date Constat" name="DateConstat" type="date" width={8} />
                <InputForm disabled label="Jours Retard" name="JoursRetard" type="number" width={8} />
                <InputForm disabled label="Base Calcul" name="BaseCalcul" type="number" money width={8} />
                <InputForm disabled label="Taux Pénalité" name="TauxPenalite" type="number" money width={8} />
                <InputForm disabled label="Montant Pénalité" name="MontantPenalite" type="number" money width={8} />
                <InputForm disabled label="Montant Encaissé" name="MontantEncaisse" type="number" money width={8} />
                <InputForm disabled label="Solde" name="SoldePenalite" type="number" money width={8} />
              </Grid>
              {/* 2ème colonne */}
              <Grid item xs={12} md={6}>
                <InputForm disabled label="Compte Créance" name="CompteCreancePenalite" type="text" width={8} />
                <InputForm disabled label="Compte Charité" name="CompteCharite" type="text" width={8} />
                <InputForm disabled label="Compte Source Client" name="CompteSourceClient" type="text" width={8} />
                <InputForm disabled label="Réf. Constat" name="RefConstat" type="text" width={8} />
                <InputForm disabled label="Réf. Encaissement" name="RefEncaissement" type="text" width={8} />
                <InputForm disabled label="Réf. Annulation" name="RefAnnulation" type="text" width={8} />
                <InputForm disabled label="Statut" name="Statut" type="text" width={8} />
                <InputForm disabled label="Date Encaissement" name="DateEncaissement" type="date" width={8} />
                <InputForm disabled label="Motif Annulation" name="MotifAnnulation" type="text" width={8} />
              </Grid>
            </Grid>
          </Spin>
        </Box>
      </Form>
    </div>
  );
}

export default Tab1;